export const UPDATE_ANALYTICS_RECORD="UPDATE_ANALYTICS_RECORD"